import ICompanyRegistrationsService from './ICompanyRegistrationsService'
import {Axios, AxiosResponse} from 'axios'
import {
    ICustomerCompanyInfoResponse,
    ISubmitProducerRegistrationBody,
    ISubmitStoreRegistrationBody,
    ISubmitRestaurantRegistrationBody,
    ISubmitAssociationRegistrationBody,
    ISubmitCampsiteRegistrationBody,
    ISubmitSkiResortRegistrationBody,
    ISubmitWorkPlaceRegistrationBody, IValidateVatNumberResponse,
} from './interfaces'
import { ENDPOINT } from "@apps/Shared/Services/Axios/Api";
import i18n from "@apps/Shared/translation/i18n";
import { clearServerMessage, renderServerMessage } from "@apps/Shared/Utils/ServerMessage";
import { Client } from "@apps/Shared/Services/Axios";
import {ICustomAxiosResponse} from "@apps/Shared/Services/Response.types";

class CompanyRegistrationsService implements ICompanyRegistrationsService {
    async GetSupplierCompanyInfo(orgnr: string, type: string) {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.SupplierCompanyRegistrations.SupplierCompanyInfo(orgnr, type)}`);
            clearServerMessage();
        }
        catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCustomerCompanyInfo(orgnr: string) {
        let res: AxiosResponse<ICustomerCompanyInfoResponse>;

        try {
            res = await Client('get', `${ENDPOINT.CustomerCompanyRegistrations.CustomerCompanyInfo(orgnr)}`);
            clearServerMessage();
        }
        catch (error: any)
        {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetCountries() {
        let res: AxiosResponse;

        try {
            res = await Client('get', `${ENDPOINT.SupplierBaseData.Countries()}`);
            clearServerMessage();
        }
        catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async GetMunicipalities(): Promise<ICustomAxiosResponse> {
        let res: ICustomAxiosResponse = {
            errors : []
        }

        await Client(
            'get',
            `${ENDPOINT.CustomerCompanyRegistrations.Municipalities()}`
        )
            .then((response: AxiosResponse<ICustomAxiosResponse>) => {
                res.response = response
                clearServerMessage()
            })
            .catch((error: Record<string, any>) => {
                console.log(error)

                renderServerMessage('error', i18n.t('error.disruptions'))

                res.errors = [i18n.t('error.fetchMunicipalities')]
            })

        return res
    }

    async GetAssociationHeards() {
        let res: ICustomAxiosResponse = {
            errors: []
        };

        await Client(
            'get',
            `${ENDPOINT.CustomerCompanyRegistrations.AssociationHeards()}`
        )
            .then((response: AxiosResponse<ICustomAxiosResponse>) => {
                res.response = response
                clearServerMessage()
            })
            .catch((error: Record<string, any>) => {
                console.log(error)

                renderServerMessage('error', i18n.t('error.disruptions'))

                res.errors = [i18n.t('error.fetchAssociationHeards')]
            })

        return res
    }

    async GetCampsiteHeards() {
        let res: ICustomAxiosResponse = {
            errors: []
        };

        await Client(
            'get',
            `${ENDPOINT.CustomerCompanyRegistrations.CampsiteHeards()}`
        )
            .then((response: AxiosResponse<ICustomAxiosResponse>) => {
                res.response = response
                clearServerMessage()
            })
            .catch((error: Record<string, any>) => {
                console.log(error)

                renderServerMessage('error', i18n.t('error.disruptions'))

                res.errors = [i18n.t('error.fetchCampsiteHeards')]
            })

        return res
    }

    async GetSkiResortHeards(): Promise<ICustomAxiosResponse> {
        let res: ICustomAxiosResponse = {
            errors: []
        }

        await Client(
            'get',
            `${ENDPOINT.CustomerCompanyRegistrations.SkiResortHeards()}`
        )
            .then((response: AxiosResponse<ICustomAxiosResponse>) => {
                res.response = response;
                clearServerMessage();
            })
            .catch((error: Record<string, any>) => {
                console.log(error);

                renderServerMessage('error', i18n.t('error.disruptions'));

                res.errors = [i18n.t('error.fetchSkiResortHeards')];
            })

        return res;
    }

    async GetWorkPlaceHeards() {
        let res: ICustomAxiosResponse = {
            errors: []
        }

        await Client(
            'get',
            `${ENDPOINT.CustomerCompanyRegistrations.WorkPlaceHeards()}`
        )
            .then((response: AxiosResponse<ICustomAxiosResponse>) => {
                res.response = response
                clearServerMessage()
            })
            .catch((error: Record<string, any>) => {
                console.log(error)

                renderServerMessage('error', i18n.t('error.disruptions'))

                res.errors = [i18n.t('error.fetchWorkPlaceHeards')]
            })

        return res;
    }

    async ValidateOrganisationNumber(
        organisationType: 'supplier' | 'customer',
        organizationNumber: string
    ) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'get',
                `${ENDPOINT.CompanyRegistrations.ValidateOrgNr(
                    organisationType,
                    organizationNumber
                )}`
            );
            clearServerMessage();
        }
        catch (error: any)
        {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async ValidateVatNr(vatNumber: string) {
        let res: ICustomAxiosResponse<IValidateVatNumberResponse> = {
            errors: []
        }

        await Client(
            'get',
            `${ENDPOINT.SupplierCompanyRegistrations.ValidateVatNr(vatNumber)}`
        )
            .then((response: AxiosResponse<IValidateVatNumberResponse>) => {
                res.response = response
                clearServerMessage()
            })
            .catch((error: Record<string, any>) => {
                console.log(error)

                if (error.response.data.message){
                    res.errors = [error.response.data.message]
                }else {
                    renderServerMessage('error', i18n.t('error.disruptions'))
                    res.errors = [i18n.t('error.unspecified')]
                }
            })

        return res
    }

    async SubmitSupplierRegistration(values: ISubmitProducerRegistrationBody) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.SupplierCompanyRegistrations.SubmitSupplierRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitStoreRegistration(values: ISubmitStoreRegistrationBody) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitStoreRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitRestaurantRegistration(
        values: ISubmitRestaurantRegistrationBody
    ) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitRestaurantRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitAssociationRegistration(
        values: ISubmitAssociationRegistrationBody
    ) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitAssociationRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitCampsiteRegistration(values: ISubmitCampsiteRegistrationBody) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitCampsiteRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitSkiResortRegistration(
        values: ISubmitSkiResortRegistrationBody
    ) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitSkiResortRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }

    async SubmitWorkPlaceRegistration(
        values: ISubmitWorkPlaceRegistrationBody
    ) {
        let res: AxiosResponse;

        try {
            res = await Client(
                'post',
                `${ENDPOINT.CustomerCompanyRegistrations.SubmitWorkPlaceRegistration()}`,
                values
            );
            clearServerMessage();
        } catch (error: any) {
            console.log(error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res
    }
}

export default new CompanyRegistrationsService()